import { Component } from '@angular/core';

@Component({
  selector: 'pcs-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  get currentYear() {
    return new Date().getFullYear();
  }
}
